import { Plugin } from '@nuxt/types';
import fetchPageDataService from '@root/libs/data-fetcher/services/fetchPageData.service';
import { isPreviewValid } from '@root/common/utils/isPreviewValid';

// This logic has to be booted after initChannel has finished and created its configuration
const fetchPageData: Plugin = async (ctx) => {
  if (process.client) {
    return;
  }
  const { app, store, req, route, redirect, $sentry, error } = ctx;

  try {
    // Redirect to page without preview GET parameter if preview token not valid
    const isValidPreview = isPreviewValid(String(route.query.preview), route.params.id);
    if (route.query.preview && !isValidPreview) {
      delete route.query.preview;
      redirect(301, route.path, route.query);
    }
    await fetchPageDataService({ req, route, store, channelConfig: app.$channelConfig('config'), $sentry });
  } catch (e) {
    error(e);
  }
};

export default fetchPageData;
